import React from 'react';
import LangSelectBox from '@atoms/DefaultSelectBox';

import { LANGUAGE } from '@helpers/EnvHelper';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { isEmpty as _isEmpty, indexOf as _indexOf } from 'lodash';

const LanguageBox = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const getLanguageLabel = language => {
    switch (language) {
      case 'kr':
        return '한국어';
      case 'en':
        return 'English';
      case 'jp':
        return '日本語';
      default:
        return '한국어';
    }
  };

  const onChangeLang = id => {
    // const lang = event.target.value;
    const lang = id;

    //URL PATH 언어 셋팅
    const pathStr = location.pathname;
    const paths = pathStr.split('/');
    let refreshUrl = '';
    if (
      !_isEmpty(paths) &&
      paths.length > 1 &&
      _indexOf(LANGUAGE, paths[1]) !== -1
    ) {
      paths[1] = lang;
      refreshUrl = paths.join('/');
    } else {
      refreshUrl = `/${lang}${pathStr}`;
    }

    //쿼리 유지
    const query = queryString.parse(location.search);
    if (!_isEmpty(query)) {
      refreshUrl += '?' + queryString.stringify(query);
    }

    window.location.replace(refreshUrl); //새로고침
    // i18n.changeLanguage(lang);
    // navigate(refreshUrl);
  };

  return (
    <ul>
      <li>
        <LangSelectBox
          value={getLanguageLabel(i18n.language)}
          onChangSelect={onChangeLang}
          sId={i18n.language}
          button={({ children }) => (
            <button className="leading-none pt-[1.5px] focus:outline-none focus:shadow-none focus:ring-0 cursor-pointer flex items-center gap-x-[10px] ">
              {children}
            </button>
          )}
          options={[
            {
              id: 'kr',
              name: '한국어',
            },
            {
              id: 'en',
              name: 'English',
            },
            {
              id: 'jp',
              name: '日本語',
            },
          ]}
          name="gnb"
        />
      </li>
    </ul>
  );
};

export default observer(LanguageBox);
